<form [formGroup]="structForm" *ngIf="!isLoading" (ngSubmit)="onSubmit()">
    <mat-form-field class="label">
        <mat-label>{{ 'mapping.base.edit.label.shortLabel' | translate}}</mat-label>
        <input matInput formControlName="label">
    </mat-form-field>

    <mat-form-field class="description">
        <mat-label>{{ 'mapping.base.edit.description.shortLabel' | translate}}</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="description"></textarea>
    </mat-form-field>

    <mat-checkbox formControlName="isDefault">
        {{ 'mapping.base.edit.isDefault.shortLabel' | translate }}
    </mat-checkbox>

    <section class="actions">        
        <button type="submit" mat-icon-button color="primary" [disabled]="structForm.invalid">
            <mat-icon aria-label="Validate">check</mat-icon>
        </button>
        <button type="button" mat-icon-button (click)="onCancel()">
            <mat-icon aria-label="Cancel">clear</mat-icon>
        </button>
    </section>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
